import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTrimDetails } from './service';

const fetchTrimDetailsAsync = createAsyncThunk(
  'find-and-compare/fetchTrimDetailsAsync',
  async ({ trimId, colorId }) => {
    const response = await getTrimDetails(trimId, colorId);
    return response;
  },
);

export {
  fetchTrimDetailsAsync,
};
